
import { defineComponent, PropType } from "vue";
import { RequiredDocumentDto } from "@/apiclient/types/RequiredDocumentDto";
import ToolTip from "../common/ToolTip.vue";
import { mapGetters, mapMutations } from "vuex";
import * as apiClient from "@/apiclient/";
import messages from "@/config/messages";
import helper from "@/utils/helper";
import store from "@/store";

export default defineComponent({
  name: "RequiredDocument",
  props: {
    document: { type: Object as PropType<RequiredDocumentDto>, required: true },
    loopIndex: { type: Number as PropType<number>, required: true },
  },
  components: {
    ToolTip,
  },
  data() {
    return {
      validationMsg: "" as string,
      files: [],
    };
  },
  methods: {
    triggerFileUpload() {
      var element = this.$refs.fileUpload as any;
      element.click();
    },
    async deleteDocument() {
      var params = {
        electionUploadId: this.document.currentDocument?.electionUploadId,
        customerParticipantId: this.getEnrollment.customerParticipantId,
      };

      var result = await apiClient
        .documentController()
        .deleteApiDocument(params);

      if (result.data) {
        const newFiles = this.getDocumentsUploaded.filter(
          (f: { electionUploadId: number }) =>
            f.electionUploadId !==
            this.document.currentDocument?.electionUploadId
        );
        this.setDocumentsUploaded(
          newFiles.map((file: any) => {
            file.disabled = false;
            return file;
          })
        );
        this.$emit("refreshData");
      }
    },
    async uploadFile(event: any) {
      this.files = Array.from(event.target.files);

      if (!this.files.length) return;
      if (this.notValidFileType()) {
        this.setShowModal(true);
        this.setModalTitle("Alert!");
        this.setModalContent(messages.notAllowedDocument);
        return;
      }

      this.setTotalFiles(this.files.length);
      var failedFile = false;
      for (let index = 0; index < this.files.length; index++) {
        var file = this.files[index] as any;

        this.setUploadedFiles(index + 1);
        this.setUploadFile({
          name: file.name,
          type: file.type,
          size: file.size,
          show: true,
          disabled: false,
        });

        const params: apiClient.PostApiDocumentMutationRequest = {
          File: file,
          customerParticipantId:
            this.getEnrollment.customerParticipantId.toString(),
          custBenefitDocumentID:
            this.document.custBenefitDocumentID?.toString(),
        };

        const result = await apiClient
          .documentController()
          .postApiDocument(params);

        if (result.error) {
          failedFile = true;
          this.removeUploadProgress(index);
          this.removeUploadFile(index);
          this.validationMsg = result.error + messages.errorMsg;
          console.error("Error uploading file:", result.error);
          this.$emit("setValidationMessage", this.validationMsg);
        } else if (result.data) {
          const electionUploadId = result.data;
          const uploadedDoc = {
            fileName: file.name,
            electionUploadId,
            contentType: file.type,
            fileSize: file.size,
            disabled: false,
          };

          this.setDocumentsUploaded([
            ...this.getDocumentsUploaded,
            uploadedDoc,
          ]);

          this.$emit("refreshData");
        }
      }

      this.setTotalFiles(0);
      this.setUploadedFiles(0);
      this.removeUploadFiles();
      if (!failedFile) {
        this.$emit("setValidationMessage", "");
      }
    },
    ...mapMutations([
      "setShowModal",
      "setModalTitle",
      "setModalContent",
      "setTotalFiles",
      "setUploadedFiles",
      "removeUploadFiles",
      "setUploadFile",
      "removeUploadProgress",
      "removeUploadFile",
      "setDocumentsUploaded",
      "setDocumentSubmitBtn",
    ]),
    notValidFileType() {
      const allowedFileTypes = [
        "image/tiff",
        "image/bmp",
        "image/png",
        "image/jpeg",
        "application/pdf",
      ];

      return Array.from(this.files).some(
        (file: File) => allowedFileTypes.indexOf(file.type) === -1
      );
    },
    async downloadDocument() {
      if (this.document.currentDocument?.electionUploadId) {
        var result = await apiClient
          .documentController()
          .getApiDocumentGetDocumentElectionuploadid({
            electionUploadId: this.document.currentDocument?.electionUploadId,
          });

        if (result.data) {
          const blob = new Blob([helper.base64ToUint8Array(result.data)]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            this.document.currentDocument.fileName ?? ""
          );
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        }

        /*const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", this.document.currentDocument.fileName!);
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);*/
      }
    },
  },
  computed: {
    ...mapGetters(["getEnrollment", "getDocumentsUploaded"]),
    downloadUrl() {
      return (
        store.state.settings.apiBaseUrl +
        apiClient.getGetApiDocumentGetDocumentElectionuploadidUrl({
          electionUploadId:
            this.document.currentDocument?.electionUploadId ?? 0,
        })
      );
    },
  },
});
